/**
 * Trigger: tr_currencies_update_position
 * Purpose: Handle position conflicts when currency position is updated
 * Table: currencies
 * Event: AFTER UPDATE OF position
 */
export const TR_CURRENCIES_UPDATE_POSITION = `
CREATE TRIGGER tr_currencies_update_position
AFTER UPDATE OF position ON currencies
BEGIN
  UPDATE currencies
  SET position = old.position,
      updated_at = strftime('%s', 'now')
  WHERE _id <> new._id
    AND new.position = position;
END;
`;
